export default [
  {
    field: 'dataCriacao',
    id: 'dataCriacao',
    label: 'Data',
    minWidth: 10,
    align: 'left',
  },
  {
    field: 'nome',
    id: 'nome',
    label: 'Título',
    // subfield: 'titulo',
    minWidth: 50,
    maxWidth: 130,
    align: 'left',
  },
  {
    field: 'descricao',
    id: 'descricao',
    label: 'Descrição',
    minWidth: 100,
    maxWidth: 300,
    align: 'left',
  },
  {
    field: 'menu',
    id: 'menu',
    label: 'Menu',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'palavrasChave',
    id: 'palavrasChave',
    label: 'Palavras-Chave',
    minWidth: 100,
    maxWidth: 300,
    overflowWrap: 'break-word',
    align: 'left',
  },
  {
    field: 'parceiro',
    id: 'parceiro',
    label: 'Provedor',
    subfield: 'nome',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'status',
    id: 'status',
    label: 'Status',
    minWidth: 100,
    align: 'left',
  },
];
